module.exports = __webpack_public_path__ + "img/project1.61bda809.jpeg";